export default {
      id: "icon_stats_possession-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#icon_stats_possession-usage",
      toString: function () {
        return this.url;
      }
    }